import React, { useEffect, useState } from 'react';
import { Button, Card, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaBan, FaCheck } from 'react-icons/fa';
const CotisationSel = ({ handleChoixCotisation, closemodal, cotisationIdSel, choixIdSel }) => {

    const cotisations = JSON.parse(localStorage.getItem('cotisations')) || [];
    const columns = [
        { name: 'Reference', width: '120px', selector: row => row.reference, sortable: true, wrap: true },
        { name: 'Titre', selector: row => row.titre, sortable: true, wrap: true },
        { name: 'Libellé', selector: row => row.libelle, sortable: true, wrap: true },
        { name: 'Tribu montant', width: '130px', selector: row => row.tribu_montant + ' €', sortable: true, wrap: true },
        { name: 'Trois fois', width: '100px', selector: row => row.trois_fois === 1 ? <FaCheck style={{ color: 'green' }} /> : <FaBan style={{ color: 'red' }} />, sortable: true, wrap: true },
        { name: 'Six fois', width: '100px', selector: row => row.six_fois === 1 ? <FaCheck style={{ color: 'green' }} /> : <FaBan style={{ color: 'red' }} />, sortable: true, wrap: true },
    ];

    const [data, setData] = useState(cotisations);

    const handleRowClick = (row) => {
        console.log('handleRowClick', row);
        const updatedData = data.map(item => {
            if (row.id !== cotisationIdSel) {
              return item;
            }
      
            return {
              ...item,
              toggleSelected: !item.toggleSelected
            };
          });
      
          setData(updatedData);

        handleChoixCotisation({ ...row ,cotisation_id: row.id, choix_id: 0 }, 1);
        closemodal();
    }

    const handleCellClick = (e, nbfois) => {
        console.log('handleCellClick', e, nbfois);
        handleChoixCotisation({ ...e, cotisation_id: e.cotisation_id, choix_id: e.id }, nbfois);
        closemodal();
    }

    const conditionalRowStyles = [
        {
          when: row => row.id===cotisationIdSel,
          style: {
            backgroundColor: "bisque",
            userSelect: "none"
          }
        }
      ];

    const ExpandedComponent = ({ data }) => {

        let myChoix = JSON.parse(data.choix);

        return <Card>
            <Card.Header>Choix de cotisation</Card.Header>
            {/* <Card.Body> */}
            <Table striped bordered hover style={{ margin: 'auto', }}>
                <thead>
                    <tr>
                        {/* <th>Ordre</th> */}
                        <th>Libelle</th>
                        <th>Montant</th>
                        {data.trois_fois === 1 && <th>En 3 fois</th>}
                        {data.six_fois === 1 && <th>En 6 fois</th>}
                    </tr>
                </thead>
                <tbody>
                    {
                        myChoix.map((e) => (
                            <tr>
                                <td style={{ backgroundColor: choixIdSel === e.id ? 'bisque' : '' }}>{e.libelle}</td>
                                <td style={{ backgroundColor: choixIdSel === e.id ? 'bisque' : '' }} onClick={() => handleCellClick(e, 1)}><Button variant='link'>{e.montant}&nbsp;€</Button></td>
                                {data.trois_fois === 1 && <td style={{ backgroundColor: choixIdSel === e.id ? 'bisque' : '' }} onClick={() => handleCellClick(e, 3)}><Button variant='link'>{Math.ceil(e.montant / 3)}&nbsp;€</Button></td>}
                                {data.six_fois === 1 && <td style={{ backgroundColor: choixIdSel === e.id ? 'bisque' : '' }} onClick={() => handleCellClick(e, 6)}><Button variant='link'>{Math.ceil(e.montant / 6)}&nbsp;€</Button></td>}
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
        </Card>
            // <pre>{JSON.stringify(data.choix, null, 2)}</pre>
            ;
    }

    return (
        <div>
            <DataTable
                columns={columns}
                data={cotisations}
                highlightOnHover
                defaultSortField="id"
                defaultSortAsc={false}
                subHeaderAlign="left"
                noHeader={true}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
                onRowClicked={handleRowClick}
                conditionalRowStyles={conditionalRowStyles}
            />
        </div>
    );
}

export default CotisationSel;
